var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-width":"300px","min-height":"400px"},attrs:{"id":_vm.graphName}})
}
var staticRenderFns = []

export { render, staticRenderFns }